export default "__VITE_PUBLIC_ASSET__1c3635d1__"